import { render, staticRenderFns } from "./KetcherEditor.vue?vue&type=template&id=45169fd2&scoped=true"
import script from "./KetcherEditor.vue?vue&type=script&lang=js"
export * from "./KetcherEditor.vue?vue&type=script&lang=js"
import style0 from "./KetcherEditor.vue?vue&type=style&index=0&id=45169fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45169fd2",
  null
  
)

export default component.exports